import { useState } from 'react'; 
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import api from '../../../app/api';

const LoginModal = (props) => {
  const { show, setShow } = props;
  
  const [ user, setUser] = useState({email:'', name: '', surname: '', password:''});
  const [ registering, setRegistering] = useState(false);

  const handleClose = () => {
    setShow(false);
  }

  const handleRegister = async () => {
    props.setLoading(true);
    await api.post(
      '/auth/register',
      user,
      {
        withCredentials: true
      }
    ).then((r) => {
      props.setErrorTitle("Thank you for registering");
      props.setErrorMessage("You are now registered and you will recieve an activation email soon." + 
        " Please check your email and click the activation link to activate your account.");
      updateEmail('');
      updatePassword('');
      updateName('');
      updateSurname('');      
      props.setShow(false);
      setRegistering(false);
      props.setErrorShow(true);
      props.setLoading(false);
    })
    .catch((error) => {
      if(error.response && error.response.status === 409) {
        props.setErrorTitle("Invalid Registration Details");
        props.setErrorMessage("This user already exists, please check and try again.");
      } else {
        props.setErrorTitle("Failed to Register");
        props.setErrorMessage("An error occurred whilst saving your data. Please try again.");        
      }
      props.setErrorShow(true);
      props.setLoading(false);
    });
  }
  
  const handleLogin = async () => {
    props.setLoading(true);
    await api.post(
      '/auth/login',
      {email: user.email, password: user.password},
      {
        withCredentials: true
      }
    ).then((r) => {
      if (r.status === 202) {
        props.setLoading(false);
        props.setMfaDetails(r.data)
        props.setShowMfa(true);
      } else {   
        props.handleLoggedIn();
        props.handleEmailUpdate(r.data.email);
        props.handleNameUpdate(r.data.name);
        props.handleSurnameUpdate(r.data.surname);
        props.handleMfaEnabled(r.data.mfaEnabled);
        props.handleMfaType(r.data.mfaType);
        setShow(false);
        api.get('/api/profiles/data')
        .then((response) => {
          if (response.status === 200 && response.data.selectedProfile !== undefined) {
            props.handleSave(response.data);
            props.setLoading(false);
          } else {
            api.post('/api/profiles/data',
            {
              selectedProfile: {id:props.profile.id, name:props.profile.name, yearCalc: props.profile.yearCalc},
              income: props.income.records,
              expenses: props.expenses.records,
              debt: props.debt,
              descriptions: [...props.income.descriptions, ...props.expenses.descriptions, ...props.debt.descriptions],
              profiles: []
            }
          )
          .then((postResponse) => {
            props.handleSave(postResponse.data);
            props.setLoading(false);
          })
          .catch((error) => {
            props.setErrorTitle("Failed to get save data");
            props.setErrorMessage("An error accurred whilst saving your data. Please try again.");
            props.setErrorShow(true);
            props.setLoading(false);
          })
        }
        })
        .catch((error) => {
          props.setErrorTitle("Failed to get your data");
          props.setErrorMessage("An error accurred whilst fetching your data. Please try again.");
          props.setErrorShow(true);
          props.setLoading(false);
        });
      }     
    })
    .catch((error) => {
      if (error.response && error.response.status === 406) {
        props.setActivateTitle("Account Not Activated");
        props.setActivateMessage("Your account has not been activated. Please check your email for the activation link." +
          " If you did not receive an email, you can request a new activation link.");
        props.setActivateSuccess(false);
        props.setActivateShow(true);
        const resetUser = {email:'', name: '', surname: '', password:''};      
        setUser(resetUser);
      } else if (error.response?.status === 400 || error.response?.status === 401) {
        props.setErrorTitle("Invalid Login Details");
        props.setErrorMessage("The email or password you entered is incorrect. Please check and try again.");
        props.setErrorShow(true);
      } else {
        props.setErrorTitle("Login Failed");
        props.setErrorMessage("We couldn't connect you to your account. Check your connection and try again.");
        props.setErrorShow(true);
      }
      setShow(false);
      props.setLoading(false);
    });
  }
  
  const updateEmail = (e) => {
    let updateUser = {...user};
    updateUser.email = e;
    setUser(updateUser);
  }
  
  const updatePassword = (e) => {
    let updateUser = {...user};
    updateUser.password = e;
    setUser(updateUser);
  }

  const updateName = (e) => {
    let updateUser = {...user};
    updateUser.name = e;
    setUser(updateUser);
  }

  const updateSurname = (e) => {
    let updateUser = {...user};
    updateUser.surname = e;
    setUser(updateUser);
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{registering?'Register':'Log in'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
              htmlFor='email'>Email</Form.Label>
            <Form.Control
              key='email'
              className="mt-0"
              type="text"
              value={user.email}
              onChange={(e) => updateEmail(e.target.value)}
            />
            {registering?
              <>
                <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                  htmlFor='name'>Name</Form.Label>
                <Form.Control
                  key='name'
                  className="mt-0"
                  type="text"
                  value={user.name}
                  onChange={(e) => updateName(e.target.value)}
                />
                <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                  htmlFor='surname'>Surname</Form.Label>
                <Form.Control
                  key='surname'
                  className="mt-0"
                  type="text"
                  value={user.surname}
                  onChange={(e) => updateSurname(e.target.value)}
                />
              </>:<></>
            }
            <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
              htmlFor='password'>Password</Form.Label>
            <Form.Control
              key='password'
              className="mt-0"
              type="password"
              value={user.password}
              onChange={(e) => updatePassword(e.target.value)}
            />
            <p style={{fontSize: '0.6em', color: 'blue', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => setRegistering(!registering)}>
              {registering?'Log in':'Register'}
            </p>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {registering?            
            <Button variant="primary" onClick={() => handleRegister()}>
              Register
            </Button>:
            <Button variant="primary" onClick={() => handleLogin()}>
              Log in
            </Button>
          }
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LoginModal;